import { createContext } from 'react';
import type { User } from '../api/authService';

export interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
}

export interface AuthContextType {
  authState: AuthState;
  setAuthState: (state: AuthState) => void;
  user: User | null;
  isAuthenticated: boolean;
  login: (email: string, password: string, recaptchaToken: string) => Promise<User>;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

